import { Component, inject, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SeoService } from 'src/app/services/seo.service';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { LogEventsEnum } from 'src/app/firebase.model';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LotItemComponent } from './lot-item/lot-item.component';
import { DesktopViewComponent } from './desktop-view/desktop-view.component';

@Component({
  selector: 'app-lots',
  templateUrl: './lots.component.html',
  styleUrls: ['./lots.component.css'],
  standalone: true,
  imports: [
    FontAwesomeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
    LotItemComponent,
    DesktopViewComponent
],
})
export class LotsComponent implements OnInit {
  private analytics = inject(Analytics);
  isWideScreen = true;
  logEvents: LogEventsEnum;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private seoService: SeoService
  ) {
    this.breakpointObserver
      .observe([
        Breakpoints.Handset, // Mobile devices (max-width: 599.98px portrait)   (max-width: 959.98px) and (orientation: landscape)
        Breakpoints.TabletPortrait, // Tablets in portrait mode (min-width: 600px) and (max-width: 839.98px)
        Breakpoints.WebPortrait, //(min-width: 840px) and (orientation: portrait)
      ])
      .subscribe((result) => {
        // this.isWideScreen = !result.matches;
        // console.log(result);
        // console.log(
        //   'is handset',
        //   this.breakpointObserver.isMatched(Breakpoints.HandsetPortrait)
        // );
        if (this.breakpointObserver.isMatched(Breakpoints.HandsetPortrait)) {
          this.isWideScreen = false;
        } else {
          this.isWideScreen = true;
        }
      });
  }

  ngOnInit(): void {
    this.seoService.updateMetaTags([
      { name: 'description', content: 'Bids and Offers Main Page' },
      { name: 'keywords', content: 'Trading Platform' },
    ]);
    this.seoService.updateTitle('Bids and Offers');
    logEvent(this.analytics, LogEventsEnum.lots_list_view);
  }
}
